import { Dialog as MuiDialog } from '@mui/material';

export default MuiDialog;
